module.exports = __webpack_public_path__ + "static/media/logo-governo-ro.0448405a.png";